// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"688":"WxLaunchHack","962":"QQShare"}[chunkId] || chunkId) + "." + {"388":"1bb6904c3f","688":"7a55fa40d6","962":"cb260db386"}[chunkId] + ".js";
};